// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"eS-z","inlineTitle":"fS-z","sponsoredAdsWrapper":"gS-z","marketplaceRecosWrapper":"hS-z"};